import defaultUser from "assets/img/user-silhouette.svg";
export function insteadIMG(path) {
  let img = path !== "" ? path : defaultUser;
  return img;
}
